import { DateTime, Duration } from "@tento-chrono";

/**
 * Snap a dragged time to the NEAREST 15-minute slot.
 *
 * The drag gestures used to floor. A pointer that travels exactly one hour of
 * pixels can land a hair short of it (fractional pointer coordinates, a
 * px-per-hour that is not an exact integer), and flooring turned that hair into
 * a whole slot: a 48px (one hour) drag moved the event +45 minutes.
 * Rounding keeps the snapped slot the one the pointer is visibly over.
 *
 * Rounds through `add` rather than `TimeOfDay.round`, which wraps 23:53 to
 * 00:00 of the SAME day; `add` rolls into the next day instead.
 */
export function snapToNearestQuarterHour<Tz extends string>(
  raw: DateTime<Tz>,
): DateTime<Tz> {
  const floored = raw.withTime(raw.time.floor(Duration.Time.MIN15));
  const past = raw.durationSince(floored).toMinsF;
  return past >= 7.5 ? floored.add(Duration.Time.MIN15) : floored;
}
